import { h, Component } from 'preact';
import style from './style.css';
import Header from '../Header'
import cx from 'classnames';
import { goToTop } from 'react-scrollable-anchor'

class TermsOfUse extends Component {
    render(props) {
        goToTop()
        return <div className={cx(style.list, 'flex', 'flex-col')}>
        <Header leadingSlash='/' />
        <div>
            <ol>
            <h1>Disclaimer</h1>
            <br />
<h3>No Offer to Buy or Sell</h3>
 
The content of this website does not in any way constitute an offer to sell or solicitation to buy securities of Playerindex or otherwise.
<br />
<br />
<h3>Links to Other Websites</h3>
 
Links to third party websites are provided solely as a convenience to you. If you use these links, you will leave this website. Playerindex has not reviewed all of these third party websites and does not control and is not responsible for any of these websites, or their content. Playerindex does not adopt statements made in any third party website.
<br />
<br />
<h3>Content Disclaimer</h3>
 
Whilst Playerindex uses reasonable efforts to include accurate, complete and current (as of the date posted) information on this website, however, it does not warrant that the content herein is accurate, complete, current or free of technical or typographical error. Further, information provided is given as at the date of release and as such may no longer be true. Playerindex does not undertake to update information. It is your responsibility to verify any information before relying on it. Playerindex reserves the right to amend and or update information contained within this website without prior notice.
<br />
<br />
<h3>User Responsibilities</h3>
 
Access to and use of this website and the content herein is at the risk of the user. NEITHER PLAYERINDEX NOR ANY PARTY INVOLVED IN CREATING, PRODUCING OR DELIVERING THIS WEBSITE SHALL BE LIABLE FOR ANY DIRECT, INCIDENTAL, CONSEQUENTIAL, INDIRECT OR PUNITIVE DAMAGES OR ANY DAMAGES WHATSOEVER ARISING OUT OF YOUR ACCESS, USE OR INABILITY TO USE THIS WEBSITE OR ANY OTHER HYPERLINKED WEBSITE OR ANY ERRORS OR OMISSIONS IN THE CONTENT THEREOF.
<br />
<br />
<h3>Caution Regarding Forward-looking Statements</h3>
 
The information contained on this website, including any analysts' reports, is not intended to be investment advice. Publication of any analysts' reports should not in any way be interpreted as an endorsement or approval of them by Playerindex and the company takes no responsibility for them.
<br />
Users are cautioned that any forward-looking statements contained in this website involve risk and uncertainties which may cause the actual results, performance or achievements of the company to be materially different from the results, performance of achievements expressed or implied by such statements.

</ol>
        </div>
    </div>;
    }
}
export default TermsOfUse;



// WEBPACK FOOTER //
// ./components/TermsOfUse/index.jsx